import { isEmpty } from 'lodash';

import { useParams } from 'react-router-dom';

import { TrackingEventEnum } from '~src/main/hooks/useTracking';

import { useShipmentDetailsQuery } from '../queries';
import { ShipmentUpsert } from '../types';
import { CreatePage } from './page';

export function CreateReturnPage() {
  const { id } = useParams();
  const shipment = useShipmentDetailsQuery({ id: id });

  /**
   * Since we're creating a return shipment,
   * we basically reverse the sender & receiver addresses.
   *
   * Other than that, we also unset a few fields that doens't
   * make sense to define on a return shipment.
   */
  const returnShipment: ShipmentUpsert = {
    ...shipment,
    contact_from: !isEmpty(shipment.customer_info?.contact) ? shipment.customer_info?.contact : shipment.contact_to,
    contact_to: !isEmpty(shipment.contact_return) ? shipment.contact_return : shipment.contact_from,
    contact_return: undefined,
    direction_type: 'RETURN',
    location_type: undefined,
    outbound_shipment_id: id,
    location_ref: undefined,
  };

  return (
    <CreatePage
      onSuccessEvent={TrackingEventEnum.ShipmentCreateReturnCompleted}
      onErrorEvent={TrackingEventEnum.ShipmentCreateReturnFailed}
      onInitEvent={TrackingEventEnum.ShipmentCreateReturnStart}
      shipment={returnShipment}
    />
  );
}
